<style lang='less'>
.app-header-message-vue {
  float: left;
  margin-right: 15px;
  .h-dropdowncustom-show {
    height: @layout-header-height;
    .app-header-icon-item {
      margin-right: 0;
    }
    &.h-pop-trigger {
      background: @hover-background-color;
    }
  }
}
.app-message-dropdown-dropdown-container {
  width: 300px;
  min-height: 300px;
  .message-list-container {
    .common-list-item {
      cursor: pointer;
      padding: 0px 25px;
      &:hover {
        background: @hover-background-color;
      }
      .description {
        font-size: 13px;
        color: @gray-color;
      }

      .title {
        position: relative;
      }

      &.readed {
        color: @gray-color;
      }

      &.unReaded .title:before{
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        background: @red-color;
        border-radius: 5px;
        left: -10px;
        top: 5px;
      }
    }
  }
}
</style>
<template>
  <DropdownCustom class="app-header-message-vue" placement="bottom-end" className="app-message-dropdown" :toggleIcon="false" ref="messageDropdown">
    <div class="app-header-icon-item">
      <Badge :count="total">
        <i class="h-icon-bell"></i>
      </Badge>
    </div>
    <div slot="content">
      <div class="h-panel">
        <div class="h-panel-bar h-panel-bar-s">
          <span class="h-panel-title">Notificações</span>
        </div>
        <div class="message-list-container common-list-container">
          <div class="common-list-item unReaded" v-for="m of messageList" :key="m._id" @click="goMessageDetail(m)">
            <router-link :to="`/notificacao/${m._id}`" exact>
              <div class="common-list-meta">
                <p class="title">{{m.titulo}}</p>
                <p class="description">{{dateFormatter(m.criadoEm)}}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="messageList.length === 0" class="text-center h-panel-bar"><span class="link" @click="irParaMensagens">Ir para listagem de notificações</span></div>
        <div v-if="messageList.length > 0" class="text-center h-panel-bar"><span class="link" @click="irParaMensagens">Veja mais</span></div>
      </div>
    </div>
  </DropdownCustom>
</template>
<script>

import manba from 'manba';

// 2 minutos
const timeRefresh = 1000 * 60 * 2;

export default {
  data() {
    return {
      total: 0,
      messageList: []
    };
  },
  created() {
    const _this = this;
    this.$root.$on('hook:update_mensagens', function () {
      _this.init();
    });
  },
  mounted() {
    this.init();
  },
  methods: {
    dateFormatter(data) {
      return manba(data).format('DD/MM/YYYY hh:mm:ss');
    },
    init() {
      this.getMessageList();
      setInterval(this.getMessageList, timeRefresh);
    },
    irParaMensagens() {
      this.$router.push({ name: 'notificacao' });
      this.$refs.messageDropdown.hide();
    },
    getMessageList: async function () {
      const resp = await R.Notificacao.naoLidas();
      if (resp && resp.ok) {
        if (resp.total > 0 && (this.total < resp.total)) {
          const newHash = resp.header.hash;
          const hash = Utils.getLocal('v360.notify.hash');
          if (hash !== newHash) {
            Utils.saveLocal('v360.notify.hash', newHash);
            Utils.notify('Novas mensagens não lidas');
          }
        }
        this.messageList = resp.data;
        this.total = resp.total;
      }
    },

    goMessageDetail() {
      this.$refs.messageDropdown.hide();
    }
  }
};
</script>
